import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-localization',
    templateUrl: './localization.component.html',
    styleUrls: ['./localization.component.scss']
})
export class LocalizationComponent implements OnInit {
    @Input() localizationModel: any;
    @Input() firstTabLangCode:string = 'hu';
    @Input() withCopy:boolean = true;
    copyEnabled:boolean = true;
    constructor() {
    }

    ngOnInit() {
    }

    trackByFn(index, item) {
        return index;
    }

    copy(key: any) {
        Object.keys(this.localizationModel).forEach(langCode =>{
           if(langCode != this.firstTabLangCode && this.withCopy && this.copyEnabled){
                this.localizationModel[langCode][key] = this.localizationModel[this.firstTabLangCode][key];
           }
        });
    }

    tabSelectionChange() {
        Object.keys(this.localizationModel).forEach(langCode => {
            if (langCode != this.firstTabLangCode) {
                const tmp = Object.keys(this.localizationModel[langCode]).filter(langCodeKey => {
                    return this.localizationModel[langCode][langCodeKey] != undefined
                        && this.localizationModel[langCode][langCodeKey].length>0;
                });
                if(tmp.length>0){
                    this.copyEnabled = false;
                }
            }
        });
    }
}
